module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-036-retro.2863feae.jpg";